<template>
  <el-container class="view-box-padding iphone_sm">
    <el-main class="flex-col-start scrollbars_pc">
        <!-- 移动地图 -->
        <div id="container" class="geofences-map geofences_map_iphone"></div>
    </el-main>
    <!-- 右边日期保存按钮 移动 -->
    <el-aside class="genfences-add-box geofences_add_iphone">
       <div style="width:100%;">
          <div class="addressListrea">
            <div style="color:#333;font-size:20px;text-align: left;">{{$t('Search locations')}} </div>
            <!-- 搜索框 -->
            <el-input v-model="filterValue" @blur="onBlur" @focus="onFocus" size="medium " :placeholder="$t('search')" @keyup.enter.native="onSearch" style="margin-top:20px">
              <i :class="isSearch ? 'el-icon-loading el-input__icon iconSearch' : ' el-icon-search el-input__icon iconSearch'" slot="suffix" @click="onSearch"></i>
            </el-input>
            <!-- 搜索框搜索的下拉列表 -->
            <div v-if="addressList.length>0" class="addressListabs">
              <el-table
                :data="addressList"
                stripe
                @row-click="selectAddress"
                size="mini"
                :row-style="{width:'100%'}"
                :show-header="false"
                style="width:100%;">
                <el-table-column
                  prop="display_name"
                  >
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 地理围栏命名 -->
          <div class="geofencesInput">{{$t('Name the Geofence')}}:</div>
          <el-input
            style="margin-top:20px;"
            size="medium"
            maxlength = "200"
            v-model="title">
          </el-input>
          <div style="color:red;" v-if="showTitleReg">{{$t('NameBeBlank')}}</div>
          <!-- 围栏范围圈放大缩小 -->
          <div class="geofencesInput">
            <span style="color:#888;font-size:16px;text-align: left;">{{$t('Radius of the geofence in meters （1000m max.）')}}</span>
            <span style="color:#777;font-size:18px;text-align: right;">{{mapRadius * 10}}m </span>
          </div>
          <div class="block" style="margin-bottom:10px">
            <el-slider v-model="mapRadius" :format-tooltip="formatTooltip" :min="5"></el-slider>
          </div>
        </div>
      <div class="flex-row-between">
        <span class="set-time-Repeat">{{$t('Repeat')}}</span>
        <el-switch
          v-model="repeatValue"
          @change="limitrepeatValue(repeatValue)"
          active-color="#2bcf88"
          inactive-color="#888">
        </el-switch>
      </div>
      <div class="flex-row-start" style="margin-top:30px;flex-wrap:wrap;">
        <el-button v-for="(item, i) in weekSelected" :key="i" @click="onWeek(item, 'left')" :disabled="openDisabled" :class="item.isSelected ? 'select-week' : 'normal-week'">{{item.label}}</el-button>
      </div>
      <!-- 保存 -->
      <div class="geofences_btn flex-row-center-start">
        <el-button class="normalBtn" :disabled="saveGeofences" @click="onSave" style="width:35%;height:50px;font-size:20px;">{{$t('Save')}}</el-button>
        <el-button class="otherBtn" :disabled="saveGeofences" @click="onCancel" style="width:35%;height:50px;font-size:20px;margin-left:15px;border-radius:50px;">{{$t('Cancel')}}</el-button>
      </div>
    </el-aside>
  </el-container>
</template>
<script>
export default {
  name: 'GeofencesAdd',
  data () {
    return {
      isSelectedWeek: ['MON'],
      weekSelected: [
        { label: this.$t('Monday'), isSelected: true, name: 'MON' },
        { label: this.$t('Tuesday'), isSelected: false, name: 'TUE' },
        { label: this.$t('Wednesday'), isSelected: false, name: 'WED' },
        { label: this.$t('Thursday'), isSelected: false, name: 'THU' },
        { label: this.$t('Friday'), isSelected: false, name: 'FRI' },
        { label: this.$t('Saturday'), isSelected: false, name: 'SAT' },
        { label: this.$t('Sunday'), isSelected: false, name: 'SUN' }
      ],
      openDisabled: false,
      filterValue: '',
      myEmail: '',
      sendEmail: false,
      ak: 'k4So7jzlGSuRIut6D6kKar5xaYwH7co4',
      lng: 114.30,
      lat: 30.6,
      mymap: '',
      circleList: '',
      mapRadius: 50,
      addressList: [],
      isSearch: false,
      marker: '',
      saveGeofences: false,
      title: '',
      showTitleReg: false,
      repeatValue: true
    }
  },
  methods: {
    // 时长下面的开关
    limitrepeatValue (v) {
      if (v === false) {
        this.openDisabled = true
        this.weekSelected.map((c) => {
          c.isSelected = false
        })
      } else {
        this.openDisabled = false
        this.weekSelected.map((c, index) => {
          if (c.name === this.isSelectedWeek[index]) {
            c.isSelected = true
          }
        })
      }
    },
    onWeek (item, type) {
      if (type === 'left') {
        this.setSelected(this.isSelectedWeek, item)
      }
    },
    // 星期几数据传入对应选取逻辑
    setSelected (week, item) {
      if (week.length <= 1) {
        if (week.indexOf(item.name) === -1) {
          item.isSelected = !item.isSelected
          week.push(item.name)
        }
      } else {
        if (week.indexOf(item.name) === -1) {
          item.isSelected = !item.isSelected
          week.push(item.name)
        } else {
          item.isSelected = !item.isSelected
          let index = week.indexOf(item.name)
          week.splice(index, 1)
        }
      }
    },
    onBlur () {
      setTimeout(() => {
        this.addressList = []
      }, 200)
    },
    onFocus () {
      this.onSearch()
    },
    formatTooltip (val) {
      return val * 10
    },
    onCancel () {
      // this.$router.push({ path: `/User/Demo/Device/Geofences` })
      this.$router.push({ path: `/User/${this.$route.params.userid}/${this.$route.params.device}/Geofences` })
    },
    async onSave () {
      if (this.title === '') {
        this.showTitleReg = true
      }
      if (this.title !== '') {
        this.saveGeofences = true
        this.showTitleReg = false
        let radius = this.mapRadius * 10
        let selectWeek = this.weekSelected.filter(c => c.isSelected)
        let weeks = []
        for (let i = 0; i < selectWeek.length; i++) {
          weeks.push(selectWeek[i].name)
        }
        let weekOne = '[' + weeks.toString() + ']'
        console.log(weekOne, this.title, radius)
        console.log(this.lng, this.lat)
        // if (this.$Demo) {
        //   setTimeout(() => {
        //     this.$router.push({ path: `/User/Demo/Device/Geofences` })
        //   }, 100)
        // }
        const type = await this.$http.get('MDM/Geofences/Add', {
          params: {
            title: this.title,
            longitude: this.lng,
            latitude: this.lat,
            radius: radius,
            week: weekOne
          }
        })
        if (type.statusText === 'OK') {
          this.$message({
            showClose: true,
            message: this.$t('add Successfully'),
            type: 'success'
          })
          this.saveGeofences = false
          this.$router.push({ path: `/User/${this.$route.params.userid}/${this.$route.params.device}/Geofences` })
        }
      }
    },
    selectAddress (row) {
      console.log(row.display_name)
      this.filterValue = row.display_name
      this.lat = row.lat
      this.lng = row.lon
      this.addressList = []
      console.log(row.lat, row.lon)
      this.creatMap(true)
    },
    // 搜索逻辑
    onSearch () {
      let str = this.filterValue.replace(/(^\s*)|(\s*$)/g, '')
      if (str.length > 0) {
        this.isSearch = true
        var $ = window.$
        console.log(str)
        let url = `https://nominatim.openstreetmap.org/search?format=json&q=${this.filterValue}`
        $.getJSON(url, (data) => {
          this.addressList = data.slice(0, 10)
          if (this.filterValue.length <= 0) {
            this.addressList = []
          }
          console.log(this.addressList)
          console.log(data)
          this.isSearch = false
        })
      } else {
        this.addressList = []
      }
    },
    createdCircle (latlng, radius) {
      // console.log(latlng)
      var circle
      if (this.circleList !== '') {
        this.circleList.clearLayers()
      }
      // var nowLatlng = e.latlng;
      // 计算半径
      var L = window.L
      circle = L.circle(latlng, {
        color: '#23b8f5',
        fillColor: '#c3ecfc',
        fillOpacity: 0.50,
        radius: radius
      })
      this.circleList = L.layerGroup([circle])
      this.mymap.addLayer(this.circleList)
      let $ = window.$
      let url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latlng.lat}&lon=${latlng.lng}`
      console.log(url)
      $.getJSON(url, (data) => {
        console.log(data.display_name)
        this.filterValue = data.display_name
      })
    },
    onLocationFound () {
      var center = this.mymap.getCenter()
      this.lat = center.lat
      this.lng = center.lng
      console.log(center)
      var L = window.L
      console.log(this.marker)
      if (this.marker !== '') {
        this.marker.remove()
      }
      var myIcon = L.icon({
        iconUrl: this.$Image('center.png'),
        iconSize: [30, 30],
        popupAnchor: [-3, -76]
      })
      this.marker = L.marker([this.lat, this.lng], {icon: myIcon, draggable: true}).addTo(this.mymap)
      this.createdCircle({lat: this.lat, lng: this.lng}, this.mapRadius * 10)
      this.marker.on('mousedown ', (e) => {
        console.log(this.circleList)
        console.log('dfsdfdfsdfsdf')
        this.marker.on('mousemove', (e) => {
          this.createdCircle(e.latlng, this.mapRadius * 10)
          this.lat = e.latlng.lat
          this.lng = e.latlng.lng
        })
        this.marker.on('mouseup', (e) => {
          console.log(e.latlng)
          console.log(this.lat, this.lng)
        })
      })
    },
    onLocationError () {
      console.log('定位获取失败')
      this.onLocationFound()
    },
    creatMap: function (search) {
      var L = window.L
      if (this.mymap !== '') {
        this.mymap.remove()
      }
      console.log(this.lat, this.lng)
      // this.mymap = L.map('container').setView([this.lat, this.lng], 13)
      // this.mymap = L.map('container', {
      //     center: [51.505, -0.09],
      //     zoom: 13
      // })
      if (search) {
        this.mymap = L.map('container').setView([this.lat, this.lng], 15)
        this.onLocationFound()
      } else {
        this.mymap = L.map('container').fitWorld()
        this.mymap.locate({setView: true, maxZoom: 15, enableHighAccuracy: true})
        this.mymap.on('locationfound', this.onLocationFound)
        this.mymap.on('locationerror', this.onLocationError)
      }
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '',
        maxZoom: 18,
        id: 'mapbox.streets',
        accessToken: 'pk.eyJ1IjoidGlhbnlldDkiLCJhIjoiY2prYWh6NzJ0MzJweDNwbGVwaWNqejZuayJ9.JbnlsVeZPkOMWmwHhzk8Mw'
      }).addTo(this.mymap)
    }
  },
  created () {
    this.$nextTick(() => {
      this.creatMap()
    })
    if (this.$route.query.value) {
      this.title = this.$route.query.value
      // this.filterValue = this.$route.query.value
    }
    if (typeof jQuery === 'undefined') {
      var head = document.getElementsByTagName('head')[0]
      let script = document.createElement('script')
      script.src = '../../../static/cdn/jquery-2.1.4.min.js'
      head.appendChild(script)
    }
  },
  watch: {
    mapRadius: function (newValue) {
      // console.log(newValue)
      this.createdCircle({lat: this.lat, lng: this.lng}, newValue * 10)
    },
    filterValue: function (newValue) {
      let str = newValue.replace(/(^\s*)|(\s*$)/g, '')
      // console.log(newValue)
      console.log(str.length)
      if (str.length > 0) {
        this.onSearch(newValue)
      } else {
        this.addressList = []
      }
    }
  }
}
</script>
<style scoped>
.scrollbars_pc{
  width:40%;padding:30px 25px
}
.addressListrea{
  width:100%;
  position:relative;
}
.addressListabs{
  width:100%;
  position:absolute;
  top:70px;
  left:0;
  z-index:10000;
}
.geofencesInput{
  margin-top:30px;
  color:#333;
  font-size:20px;
  width:100%;
  text-align: left;
}
.genfences-add-box{
  width:100%!important;
  padding:0 20px;
}
.geofences-add{
  margin-top:20px;
}
.geofences-map{
  width:100%;
  height:240px;
}
.select-week{
  width: 124px;
  height: 38px;
  color: #fff !important;
  background: linear-gradient(to right, #2de075, #0dca6d);
  background-color: #10cd6c;
  border-color:#10cd6c;
  border-radius: 19px;
  margin:15px 15px 0 0;
  cursor: pointer;
}
.normal-week{
  width: 124px;
  height: 38px;
  color:#979797;
  border-radius: 19px;
  border: solid 1px #979797;
  margin:15px 15px 0 0;
  cursor: pointer;
}
.geofences_btn {
  margin-top: 18%;
}
/* .geofences_map_iphone, .geofences_add_iphone{
  display: none;
} */
.geofences_map_PC {
  display: block;
}
@media (min-width: 1024px) {
  .view-box-padding {
    height: 92%;
    background-color: #fff;
    border-radius: 20px;
  }
  .genfences-add-box{
    width:55%!important;
    padding:3% 5%;
  }
  .geofences-add{
    margin-top:0;
  }
  .geofences-map{
    width:100%;
    height:100%;
    border-radius: 20px;
  }
}
@media (max-width: 1024px) {
    /* .geofences_add_PC, .geofences_map_PC{
      display: none;
    }
    .geofences_map_iphone, .geofences_add_iphone{
      display: block;
    } */
    .iphone_sm {
      display: -moz-box;  /* Firefox */
      display: -ms-flexbox;    /* IE10 */
      display: -webkit-box;    /* Safari */
      display: -webkit-flex;
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      border-radius: 20px;
    }
    .scrollbars_pc {
      width:100%;
      /* height: 830px; */
    }
    .geofences-map {
      height: 420px;
    }
    .geofences_btn {
      margin-bottom: 30px;
      justify-content :center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/GeofencesAdd.vue